module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp123_8004.7ce9f317.png";